<div class="table-of-contents level-{{ level }}">
  @for (item of items; track item; let i = $index) {
    <div class="table-of-contents-item level-{{ level }}">
      <a [routerLink]="['./']" [fragment]="item.anchor">
        <div (click)="smoothScroll($event, item.anchor)" class="heading">
          @if (level === 0) {
            <div class="number">
              <div>{{ i + 1 }}</div>
            </div>
          }
          <div class="text">{{ item.text }}</div>
        </div>
      </a>
      @if (item.children.length) {
        <div class="children">
          <app-table-of-contents-item-list
            [items]="item.children"
            [level]="level + 1"
          ></app-table-of-contents-item-list>
        </div>
      }
    </div>
  }
</div>
